import React from 'react';
import CollectionPage from '../shared/CollectionPage';

const bookConditionOptions = [
  { value: 'Mint (M)', label: 'Mint (M)' },
  { value: 'Near Mint (NM)', label: 'Near Mint (NM)' },
  { value: 'Very Good (VG)', label: 'Very Good (VG)' },
  { value: 'Good (G)', label: 'Good (G)' },
  { value: 'Fair (F)', label: 'Fair (F)' },
  { value: 'Poor (P)', label: 'Poor (P)' },
  { value: 'Ex-Library', label: 'Ex-Library' },
  { value: 'Book Club Edition', label: 'Book Club Edition' },
  { value: 'First Edition', label: 'First Edition' }
];

const bookWishlistEditFields = [
  { name: 'name', label: 'Title', type: 'text', required: true, gridProps: { xs: 12 } },
  { name: 'author', label: 'Author', type: 'text', required: true, gridProps: { xs: 12, sm: 6 } },
  {
    name: 'format', label: 'Format', type: 'select', required: true,
    options: ['Hardback', 'Paperback', 'eBook', 'Audiobook', 'Leather Bound', 'Board Book', 'Other'],
    gridProps: { xs: 12, sm: 6 }
  },
  { name: 'condition', label: 'Condition', type: 'select', required: false, options: bookConditionOptions, gridProps: { xs: 12, sm: 6 } },
  { name: 'edition', label: 'Edition', type: 'text', required: false, gridProps: { xs: 12, sm: 6 } },
  { name: 'year', label: 'Year', type: 'number', required: false, gridProps: { xs: 12, sm: 6 } },
  { name: 'genre', label: 'Genre', type: 'text', required: false, gridProps: { xs: 12, sm: 6 } },
  { name: 'publisher', label: 'Publisher', type: 'text', required: false, gridProps: { xs: 12, sm: 6 } },
  { name: 'pages', label: 'Pages', type: 'number', required: false, gridProps: { xs: 12, sm: 6 } },
  { name: 'series', label: 'Series', type: 'text', required: false, gridProps: { xs: 12, sm: 6 } },
  { name: 'seriesNumber', label: 'Book # in Series', type: 'number', required: false, gridProps: { xs: 12, sm: 6 } },
  { name: 'isbn13', label: 'ISBN-13', type: 'text', required: false, gridProps: { xs: 12, sm: 6 } },
  {
    name: 'priority', label: 'Priority', type: 'select', required: false,
    options: ['Low', 'Medium', 'High'],
    gridProps: { xs: 12, sm: 6 }
  },
  { name: 'price', label: 'Est. Price', type: 'text', required: false, gridProps: { xs: 12, sm: 6 } },
  { name: 'rating', label: 'Rating', type: 'rating', required: false, gridProps: { xs: 12 } },
  { name: 'imageUrl', label: 'Cover Image URL', type: 'text', required: false, gridProps: { xs: 12 } },
  { name: 'notes', label: 'Notes', type: 'textarea', required: false, gridProps: { xs: 12 } }
];

const bookFilterOptions = [
  { value: '', label: 'All Formats' },
  { value: 'Hardback', label: 'Hardback' },
  { value: 'Paperback', label: 'Paperback' },
  { value: 'eBook', label: 'eBook' },
  { value: 'Audiobook', label: 'Audiobook' },
  { value: 'Other', label: 'Other' }
];

const BookWishlistDashboard = () => {
  const bookRenderProps = {
    getImageUrl: (item) => item.imageUrl,
    getItemName: (item) => item.name,
    getItemSubtitle: (item) => `${item.author || 'Unknown Author'} • ${item.format || 'Paperback'}`,
    getItemDetails: (item) => [
      item.year ? `${item.year}` : null,
      item.genre || null,
      item.series ? `${item.series}${item.seriesNumber ? ` #${item.seriesNumber}` : ''}` : null
    ].filter(Boolean).join(' • ')
  };

  return (
    <CollectionPage
      collectionType="book-wishlist"
      title="Book Wishlist"
      renderProps={bookRenderProps}
      filterOptions={bookFilterOptions}
      getFilterValue={(item) => item.format}
      editFields={bookWishlistEditFields}
      isWishlist={true}
    />
  );
};

export default BookWishlistDashboard;
